import { Card, CardContent } from "@web/components/ui/card";
import { useLanguage } from "@web/lib/contexts/language-context";
import { ShieldAlert, ShieldCheck } from "lucide-react";
import ConfidenceGauge from "./confidence-gauge";

export default function VerdictCard({
  reliabilityScore,
  status,
}: {
  reliabilityScore: number;
  status?: string;
}) {
  const { t } = useLanguage();

  const getVerdictConfig = () => {
    if (status === "PUBLIC_VALID") {
      return {
        icon: ShieldCheck,
        title: t.queryPage.verdictCard.authentic.title,
        subtitle: t.queryPage.verdictCard.authentic.subtitle,
        bgClass: "bg-gradient-to-br from-emerald-50 to-emerald-100/50",
        borderClass: "border-emerald-200",
        iconClass: "text-emerald-600",
      };
    }
    if (status === "PUBLIC_INCONCLUSIVE") {
      return {
        icon: ShieldAlert,
        title: t.queryPage.verdictCard.warning.title,
        subtitle: t.queryPage.verdictCard.warning.subtitle,
        bgClass: "bg-gradient-to-br from-amber-50 to-amber-100/50",
        borderClass: "border-amber-200",
        iconClass: "text-amber-600",
      };
    }
    return {
      icon: ShieldAlert,
      title: t.queryPage.verdictCard.suspicious.title,
      subtitle: t.queryPage.verdictCard.suspicious.subtitle,
      bgClass: "bg-gradient-to-br from-red-50 to-red-100/50",
      borderClass: "border-red-200",
      iconClass: "text-red-600",
    };
  };

  const config = getVerdictConfig();
  const Icon = config.icon;

  return (
    <Card
      className={`${config.bgClass} ${config.borderClass} border-2 overflow-hidden`}
    >
      <CardContent className="p-2">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <div className="flex items-center justify-between w-full gap-4">
            <Icon className={`h-10 w-10 ${config.iconClass}`} />

            <div className="flex flex-row flex-1">
              <div className="flex flex-col">
                <h2 className="text-lg font-bold text-foreground">
                  {config.title}
                </h2>
                <p className="text-sm text-muted-foreground text-left">
                  {config.subtitle}
                </p>
              </div>
            </div>

            <ConfidenceGauge size="sm" value={reliabilityScore / 100} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
